import { res } from "@/BaseComponent";
import { apiService } from "@/services/interceptor";

export interface Data {
    idx: number;
    meIdx: number;
    price: number;
    count: number;
    content: string;
    createDate: string;
    writer: string;
}

export interface List {
    data: Data[];
    draw: number;
    size: number;
    totalPages: number;
    recordsTotal: number;
    recordsFiltered: number;
}

interface GetList {
    page: number;
    size: number;
    startDate: string;
    endDate: string;
}

interface AddParam {
    price: number;
    count: number;
    content: string;
    createDate?: string;
}

export default {
    async getStatus(param: GetList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/charge/status", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async multiRemove(param: { idxList: string }): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/charge/multi/remove", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async remove(idx: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/charge/remove/" + idx);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async modify(idx: number, param: AddParam): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/charge/modify/" + idx, param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getList(param: GetList): Promise<res<List>> {
        const res = {} as res;
        try {
            const response = await apiService().post("/charge/list", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getDetail(idx: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/charge/detail/" + idx);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async add(param: AddParam): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/charge/add", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
